<template>
  <kitchen-table
    :page="page"
    :columns="cols"
    :allowColumnSelection="true"
    i18nItemItemCountKey="MANATEE_COUNT"
    @sort-by="updateSortBy"
    @goto-page="updatePage"
    @filter-by="filterBy"
    @column-changed="onColumnChanged"
    @column-order-changed="onColumnOrderChanged"
    :maxHeight="'100vh - ' + outsideHeaderHeight + 'px'"
  >
    <template #id.header="{ column }">
      <i>{{ column.key }}</i>
    </template>

    <template #id="{ cell }">
      <b>{{ cell }}</b>
    </template>

    <template #env-user="{ cell }">
      {{ cell }}
    </template>

    <template #runningflow="{ cell }">
      <running-flow :flow="cell" />
    </template>

    <template #details="{ row }">
      <router-link
        :to="{ name: 'estero-details', params: { id: row['Manatee/Identifier'] } }"
        style="display: inline-block; width: 100%; text-align: center;"
      >
        <i class="large arrow alternate circle right icon"></i>
      </router-link>
    </template>
  </kitchen-table>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

th#selectAll {
  pointer-events: auto;
}
</style>

<script>
// @flow
import _ from 'lodash'
import { Estero, EsteroSocket } from 'services'
import RunningFlow from './RunningFlow'
import { KitchenTable, KitchenPage } from 'ui'
import Vue from 'vue'

export default {
  name: 'estero-list',

  components: { KitchenTable, RunningFlow },

  props: {
    page: { type: Object, default: () => {} },
    outsideHeaderHeight: { type: Number, default: () => 250 },
    properties: { type: Array, default: () => [] }
  },

  data() {
    return {
      startPagination: 0,
      allSelected: false,
      orders: {},
      visibleColumns: {},
      defaultColumns: [
        {
          key: 'Env/User',
          name: this.$i18n.t('USERNAME'),
          filters: true,
          sorts: true
        },
        {
          key: 'Env/MachineName',
          name: this.$i18n.t('MACHINENAME'),
          filters: true,
          sorts: true
        },
        {
          key: 'Settings/ProductionGroup',
          name: this.$i18n.t('PRODGROUP'),
          filters: true,
          sorts: true
        },
        {
          key: 'Env/Version',
          name: this.$i18n.t('MANATEE_VERSION'),
          filters: true,
          sorts: true
        },
        {
          key: 'Manatee/Status/Flow',
          name: this.$i18n.t('RUNNING_FLOW'),
          template: 'RUNNINGFLOW'
        },
        {
          key: 'DETAILS',
          name: this.$i18n.t('ESTERO_COL_DETAILS'),
          template: 'DETAILS',
          width: '60px'
        }
      ]
    }
  },

  computed: {
    cols() {
      if (this.page.header && this.page.header.length > 0) {
        return [
          ..._.map(_.filter(this.page.header, h => h != 'Manatee/Identifier'), h => {
            let defaultColumn = _.find(this.defaultColumns, dc => dc.key === h)
            return defaultColumn || { key: h, sorts: true, filters: false }
          }),
          {
            key: 'DETAILS',
            template: 'DETAILS',
            name: this.$i18n.t('ESTERO_COL_DETAILS'),
            sorts: false,
            filters: false,
            width: '60px'
          }
        ]
      }
      return _.orderBy(
        _.uniqBy(
          [
            ..._.map(this.defaultColumns, c => ({ ...c, order: this.orders[c.key] || 0 })),
            ..._.map(this.properties, p => ({
              key: p,
              name: p,
              hidden: !this.visibleColumns[p],
              filters: true,
              sorts: true,
              order: this.orders[p] || 1
            }))
          ],
          'key'
        ),
        'order'
      )
    }
  },

  methods: {
    onColumnOrderChanged(orderedColumns) {
      // create a lookup for SPEED
      this.orders = _.reduce(
        orderedColumns,
        (memo, c) => {
          memo[c.key] = c.order
          return memo
        },
        {}
      )
    },
    onColumnChanged(col) {
      const dc = _.find(this.defaultColumns, c => c.key === col.key)
      if (dc) {
        this.$set(dc, 'hidden', col.hidden)
      } else {
        this.$set(this.visibleColumns, col.key, !col.hidden)
      }
    },
    selectAll() {
      this.allSelected = !this.allSelected
    },

    restart(item) {
      Vue.set(item, 'restarting', true)
      Estero.restart(item['Manatee/Identifier']).then(() => (item.restarting = false))
    },

    shutdown(item) {
      Vue.set(item, 'shuttingDown', true)
      Estero.shutdown(item['Manatee/Identifier']).then(() => (item.shuttingDown = false))
    },

    filterBy(t) {
      console.debug('update view', t.row, t.column)
      this.$emit('filterby-updated', `${t.column.key} = "${t.row[t.column.key]}"`)
    },

    updatePage(p) {
      this.$emit('page-updated', p)
    },

    updateSortBy(sort) {
      const sortBy = (sort.ascending ? '' : '!') + sort.by
      console.debug('sortby', sortBy)
      this.$emit('sortby-updated', sortBy)
    },

    incrementPagination() {
      this.startPagination = Math.min(this.startPagination + 1, this.page.totalPages)
    },

    decrementPagination() {
      this.startPagination = Math.max(this.startPagination - 1, 0)
    }
  },

  watch: {
    page: function() {}
  }
}
</script>
